export enum PatientNavigationEnum {
  home = 'home',
  basket = 'basket',
  profile = 'profile',
  profile_info = 'info',
  profile_edit = 'edit',
  order_list_rehabilitation = 'rehabilitation',
  order_list_education = 'education',
  order_list_service = 'service',
  calendar = 'calendar',
  order = 'order',
  telediagnosis = 'telediagnosis',
  osc = 'osc',
  ecg = 'ecg',
  joint_mobility = 'joint-mobility',
  physical_assistant = 'physical-assistant',
  access = 'access',
}
